import { createContext, useContext, type ReactNode } from "react";

import { useDialogSteps } from "ui/dialog";
import { TOTAL_CAMPAIGN_WITH_WRITER_STEPS } from "components/modals/create-campaign-with-writer-modal/create-campaign-with-writer-modal.constants";

import type { CampaignWithWriterContextType } from "components/modals/create-campaign-with-writer-modal/create-campaign-with-writer-modal.types";

const CampaignWithWriterContext = createContext<CampaignWithWriterContextType | undefined>(
  undefined,
);

interface CampaignWithWriterContextProviderProps {
  children: ReactNode;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const CampaignWithWriterContextProvider = ({
  children,
  isOpen,
  setIsOpen,
}: CampaignWithWriterContextProviderProps) => {
  const steps = useDialogSteps({ total: TOTAL_CAMPAIGN_WITH_WRITER_STEPS });

  const value = { ...steps, isOpen, setIsOpen };

  return (
    <CampaignWithWriterContext.Provider value={value}>{children}</CampaignWithWriterContext.Provider>
  );
};

export const useCampaignWithWriterContext = () => {
  const context = useContext(CampaignWithWriterContext);

  if (context === undefined) {
    throw new Error(
      "useCampaignWithWriterContext must be used within a CampaignWithWriterContextProvider",
    );
  }

  return context;
};
